import React from 'react'
import equipment from '../Images/equipments.jpg'
import device from '../Images/meddiv.jpg'
import '../Cardpage.css'
function MedicalEquip() {
  return (
    <>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Medical Equipments</h3>
      <img src={device} className='w-100 imgbanner'  alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      We have all kinds medical equipments in our Store. We only provide equipments of best quality.
    </p>
    <h5 className='cardpagehead5'>
      Major Medical Equipments we have:
    </h5>
    <div>
    <ul>
      <li>Recliner Bed</li>
      <li>Air and Water Bed</li>
      <li>Wheel Chair</li>
      <li>Oxygen Concentrators </li>
      <li>Walker</li>
      <li>Walking stick</li>
      <li>Nebulizer</li>
      <li>Glucometer</li>
      <li>Blood Pressure apparatus- Digital and Manual</li>
      <li>Pulse-Oxy meter</li>
      <li>Thermometer - Digital and Manual</li>
    </ul>
    </div>
    <p className='ms-2 pagebott'>We give Equipments with a minimum of six months Manufacturer's warranty.</p>
    </>
  )
}

export default MedicalEquip